import { Box, Container, Typography, CssBaseline, Button } from '@mui/material';
import { Grid, IconButton, Link, List, ListItem } from '@mui/material/node';
import XIcon from '@mui/icons-material/X';
import React, { useState } from 'react';
import { DonationDialog } from '../Dialogs/donationDialog';
import { SubscriptionDialog } from '../Dialogs/subscriptionDialog';
import FacebookIcon from '@mui/icons-material/Facebook';
import TwitterIcon from '@mui/icons-material/Twitter';
import InstagramIcon from '@mui/icons-material/Instagram';
import { Fade } from 'react-awesome-reveal';

export const MainFooter = () => {
  const [donationOpen, setDonationOpen] = useState(false);
  const [subscriptionOpen, setSubscriptionOpen] = useState(false);

  const socialMediaLinks = {
    facebook: '#',
    twitter: 'https://x.com/duchanito',
    instagram: '#',
  };

  return (
    <footer>
      <Container component="main" maxWidth="sm">
        <Box
          sx={{
            marginTop: 6,
          }}
        >
          <CssBaseline />

          <Box
            sx={{
              my: 8,
              mx: 4,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Typography variant="body" sx={{ mt: 6 }} align="center">
              Have feedback or something on your mind?<br /> Get in touch.<br />
              <IconButton onClick={() => window.open("https://x.com/duchanito", "_blank")} sx={{ mt: 2 }}><XIcon /></IconButton>
            </Typography>

            <Box id="supportus" sx={{ mt: 4, display: 'flex', gap: 2, flexWrap: 'wrap', justifyContent: 'center' }}>
              <Fade bottom duration={1000}>
                <Typography
                  variant="h2"
                  component="h2"
                  align="center"
                  color="text.primary"
                  gutterBottom
                  sx={{ marginBottom: 5, marginTop: 3, fontWeight: 400 }}
                >
                  Support us
                </Typography>
                <Grid container spacing={4} alignItems="center" sx={{ mb: 4, width: {sx: '100%', sm: '700px'} }}>
                  <Grid xs={12} md={6}>
                    <Typography variant="body2" color="text.primary" sx={{ m: 4 }}>
                      Any support is highly appreciated and helps us improve the platform and add new features. You can support us by making a one-time donation or subscribing to a monthly support plan. Click the 'Donate' or 'Monthly Support' buttons to get started. All payments are processed securely through Stripe. Thank you for your support!
                    </Typography>
                  </Grid>
                  <Grid xs={12} md={6} sx={{ mt: 2 }}>
                    <Box sx={{ width: '100%', textAlign: 'center', mb: 4 }}>

                      <Box
                        sx={{
                          bgcolor: 'primary.light',
                          color: 'primary.contrastText',
                          borderRadius: 2,
                          p: 2,
                          m: 2,
                          textAlign: 'center',
                          boxShadow: 1,
                        }}
                      >
                        <Typography variant="h6" sx={{ fontWeight: 600, mb: 1 }}>
                          Supporter Extras
                        </Typography>
                        <Typography align="left" variant="body2" sx={{ mb: 2 }}>
                          <List>
                          <ListItem>• Extra projects — free acount is limited to 3 projects</ListItem>  
                          <ListItem>• Export  — download your data for safekeeping</ListItem>
                          <ListItem>• Import — restore backups or import</ListItem>
                          <ListItem>• More will come in the future!</ListItem>
                          </List>
                        </Typography>
                      </Box>
                    </Box>
                  </Grid>
                </Grid>

              </Fade>

              <Button
                variant="contained"
                color="primary"
                onClick={() => setDonationOpen(true)}
                sx={{ minWidth: 150, height: 50, borderRadius: 25}}
              >
                Donate
              </Button>
              <Button
                variant="contained"
                color="primary"
                onClick={() => setSubscriptionOpen(true)}
                sx={{ minWidth: 150, height: 50, borderRadius: 25}}
              >
                Monthly Support
              </Button>
            </Box>
          </Box>
        </Box>
      </Container>

      <DonationDialog open={donationOpen} handleClose={() => setDonationOpen(false)} />
      <SubscriptionDialog open={subscriptionOpen} handleClose={() => setSubscriptionOpen(false)} />

      <Box
        sx={{
          bgcolor: 'background.paper',
          color: 'text.secondary',
          py: 3,
          borderColor: 'divider',
        }}
      >
        <Container maxWidth={false}>
          <Grid container spacing={2} justifyContent="space-between">
            <Grid item xs={12} sm={6} md={3}>
              <Typography variant="h6" color="text.primary" gutterBottom>
                NodeCanvas
              </Typography>
              <Typography variant="caption" color="text.primary" gutterBottom>
                NodeCanvas is a platform for creating and sharing visualizations of data. NodeCanvas allows you to create and share visualizations of data with others.
              </Typography>
              {/* Add your logo component or image here */}
            </Grid>
            <Grid item xs={6} sm={3} md={2}>
              <Typography variant="subtitle1" color="text.primary" gutterBottom>
                Links
              </Typography>
              <Link href="#features" color="inherit" display="block">Features</Link>
              {/* <Link href="#" color="inherit" display="block">Integrations</Link>
            <Link href="#" color="inherit" display="block">Pricing</Link> */}
              <Link href="#faq" color="inherit" display="block">FAQ</Link>
            </Grid>
            {/* <Grid item xs={6} sm={3} md={2}>
            <Typography variant="subtitle1" color="text.primary" gutterBottom>
              COMPANY
            </Typography>
            <Link href="#" color="inherit" display="block">About Us</Link>
            <Link href="#" color="inherit" display="block">Careers</Link>
            <Link href="#" color="inherit" display="block">Privacy Policy</Link>
            <Link href="#" color="inherit" display="block">Terms of Service</Link>
          </Grid> */}
            <Grid item xs={6} sm={3} md={2}>
              <Typography variant="subtitle1" color="text.primary" gutterBottom>
                Legal
              </Typography>
              <Link href="/tos" color="inherit" display="block">Terms of services</Link>
              <Link href="/privacy-policy" color="inherit" display="block">Privacy policy</Link>
            </Grid>
            <Grid item xs={6} sm={3} md={2}>
              <Typography variant="subtitle1" color="text.primary" gutterBottom>
                SOCIAL MEDIA
              </Typography>
              {/* <IconButton aria-label="Facebook" color="inherit" component="a" href={socialMediaLinks.facebook}>
              <FacebookIcon />
            </IconButton> */}
              <IconButton aria-label="Twitter" color="inherit" component="a" href={socialMediaLinks.twitter}>
                <XIcon />
              </IconButton>
              {/* <IconButton aria-label="Instagram" color="inherit" component="a" href={socialMediaLinks.instagram}>
              <InstagramIcon />
            </IconButton> */}
            </Grid>
          </Grid>
          <Typography variant="body2" color="text.secondary" align="center" sx={{ pt: 4 }}>
            © 2025 All rights reserved.
          </Typography>
        </Container>
      </Box>
    </footer>
  );
};